import * as yup from 'yup';

export const nonEmptyString = () => yup.string().trim().min(1);

export const optionalString = () => yup.string().nullable().optional();

export const optionalBoolean = () => yup.boolean().nullable().optional();

export const linkItemSchema = yup.object({
  url: optionalString(),
  name: optionalString(),
  isExternal: optionalBoolean(),
  isCurrent: optionalBoolean(),
  shouldOpenInNewWindow: optionalBoolean(),
  invisibleTextTranslation: optionalString(),
});

export const languageItemSchema = yup.object({
  url: optionalString(),
  name: optionalString(),
  code: optionalString(),
  isExternal: optionalBoolean(),
  isCurrent: optionalBoolean(),
  shouldOpenInNewWindow: optionalBoolean(),
  invisibleTextTranslation: optionalString(),
});
